import {getSingleRowActionQueryParams} from "../Components/ReactTable/helpers";
import {makeApiCallPost} from "../../Api/makeApiCall";
import {CHICAGO_TIMEZONE} from "../Alerts/MissingData/filters";
import {toInteger} from "lodash";
import moment from "moment";

export function isValidMatchingEndDate(periodParam, endDate, suffix) {
    return Boolean(
        (periodParam && endDate && periodParam.toString().length === 10)
        && (suffix === '04' || (endDate.toString().replace(/-/g, "") + suffix === periodParam.toString()))
        && (suffix === '01' || periodParam.toString().endsWith('04'))
    );

}

export function isValidSpinsWeek(spinsWeek){
    const spinsWeekRegex = new RegExp(/^\d{8}$/g);
    return spinsWeekRegex.test(spinsWeek)
}
const REFERENCE_WEEK = {
    WeekID: 1948,
    SundayWeekendDate: moment.tz("2017-01-01", "YYYY-MM-DD", CHICAGO_TIMEZONE).startOf('day')
};

function _get_iri_week(spins_end_date) {
    const spins_end_date_as_datetime = moment.tz(spins_end_date, "YYYY-MM-DD", CHICAGO_TIMEZONE).startOf('day');
    const timeDiffInMs = spins_end_date_as_datetime.diff(REFERENCE_WEEK.SundayWeekendDate);
    const daysDiff = timeDiffInMs / (1000 * 60 * 60 * 24);
    return Math.round(REFERENCE_WEEK.WeekID + daysDiff / 7);
}

export function isValidIriWeek(iriWeek, endDate){
    const expectedIriWeek = _get_iri_week(endDate);
    return Boolean(toInteger(expectedIriWeek) === toInteger(iriWeek));
}

export const COLUMNS_TO_CHECK_FOR_UNIQUE = ['insightsStart', 'adpStart', 'isCurrentPeriodWeek', 'isCurrentPeriodQuad', 'isCurrentStoreInsightsWeek', 'isCurrentStoreInsightsPeriod', 'isCurrentMarketInsightsPeriod']

export async function setAllOtherRowsToNotCurrent(endpointUrl, newData, records) {
    let fieldsUpdated = [];
    const newIndex = newData['index'];
    Object.keys(newData).forEach(key => {
        if (newData[key] === 1 && COLUMNS_TO_CHECK_FOR_UNIQUE.includes(key)) {
            fieldsUpdated.push(key)
        }
    });
    if (fieldsUpdated.length > 0) {

        const rawRecords = records.map(row => row.original)

        const activeRecords = rawRecords.filter(record => {
            let activeForFieldsUpdated = []
            fieldsUpdated.forEach(field => {
                if (record[field] === 1) {
                    activeForFieldsUpdated.push(true)
                }
            })
            return record['index'] !== newIndex && activeForFieldsUpdated.length > 0;
        })

        for (const row of activeRecords) {
            fieldsUpdated.forEach(field => row[field] = 0)
            await makeApiCallPost(endpointUrl + getSingleRowActionQueryParams("update", false), row);
        }
    }
}
